/*
 * @Author: tong.kai
 * @Date: 2020/8/26 16:20
 * @FilePath: \xjmediacloud\app\components\util\listCard\listCard.js
 * @Description:
 */
'use strict';
angular.module('listCardModule', []).directive('listCard', ['$state', 'modalDialog', 'trsHttpService', 'wechatBtnService', 'forFusionSign',
    function($state, modalDialog, trsHttpService, wechatBtnService, forFusionSign) {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: './components/util/listCard/listCard.html',
            link: function($scope) {

                /**
                 * [wxPreview description] 微信预览
                 * @param  {[type]} selectedArray [description]
                 * @param  {[type]} picWordId [description]
                 * @return {[type]}      [description]
                 */
                $scope.wxPreview = function(selectedArray, picWordId) {
                    var copyArray = angular.copy(selectedArray);
                    wechatBtnService.wxPreview(copyArray, 'preview', '', function() {
                        $scope.requestData();
                    }, picWordId);
                };

                /**
                 * [massSend description] 微信群发
                 * @param  {[type]} selectedArray [description]
                 * @param  {[type]} picWordId [description]
                 * @return {[type]}      [description]
                 */
                $scope.massSend = function(selectedArray, picWordId) {
                    modalDialog.confirmModal('群发', '稿件群发后将无法撤销，如需修改与删除只能前往微信公众平台官方后台，是否确认稿件无误并继续群发？', function() {
                        var params = {
                            serviceid: 'mlf_wechatgroupsend',
                            methodname: 'previewCardSend',
                            WechatCardMessageId: picWordId
                        };
                        var arr = [];
                        for (var i = 0; i < selectedArray.length; i++) {
                            arr.push(selectedArray[i].METADATAID);
                        }
                        params.DocIds = arr.join();
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', 'forbiden')
                            .then(function(data) {
                                modalDialog.alertType('群发任务进行中，请耐心等待', '', 'info', false, function() {
                                    $scope.status.isFirstClick = false;
                                    $scope.requestData();
                                    // $modalInstance.close('success');
                                });
                            }, function(err) {
                                $scope.status.isFirstClick = false;
                                // $modalInstance.close('success');
                                if (err.ISSUCCESS === 'false') {
                                    wechatBtnService.wxPreviewSuccess(function() {
                                    }, err, false);
                                }
                                if (err.status === '-1') {
                                    modalDialog.alertType('', err.reason, 'warning', 'confirm', function() {
                                    });
                                }
                            });
                    });

                };


                /**
                 * [wxDelete description] 微信删除
                 *  @param  {[type]} id [description]
                 * @return {[type]}      [description]
                 */
                $scope.wxDelete = function(id) {
                    modalDialog.confirmModal('删除', '是否确认删除该预览记录？', function() {
                        var params = {
                            WECHATCARDMESSAGEID: id,
                            serviceid: 'mlf_wechatgroupsend',
                            methodname: 'previewCardDelete',
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function() {
                            modalDialog.alertType('删除成功', '', 'success', false, function() {
                                $scope.requestData();
                            });
                        });
                    });
                };

                /**
                 * [toWeixinPreview description] 微信详情
                 *  @param  {[type]} item [description]
                 * @return {[type]}      [description]
                 */
                $scope.toWeixinPreview = function(item) {
                    var url = $state.href('weixinPreview', {
                        wxmetadataid: item.METADATAID,
                        wxchannelid: item.CHANNELID,
                        wxchnldocid: item.CHNLDOCID,
                        wxplatform: 2,
                        isSendState: item.massSendFalg != '0',
                    }, { reload: true });
                    window.open(url, '_blank');
                };

                /**
                 * [wxGoback description] 微信打回
                 *  @param  {[type]} id [description]
                 * @return {[type]}      [description]
                 */
                $scope.wxGoback = function(id) {
                    modalDialog.confirmModal('打回', '是否确认打回到已组版？', function() {
                        var params = {
                            WechatCardMessageId: id,
                            serviceid: 'mlf_wechatgroupsend',
                            methodname: 'rejectZuBanMessage',
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function() {
                            modalDialog.alertType('打回成功', '', 'success', false, function() {
                                $scope.requestData();
                                forFusionSign.getwxQunfaCont();
                            });
                        });
                    });
                };

                /**
                 * [deleteQunFaCard description] 微信已群发的删除
                 *  @param  {[type]} id [description]
                 * @return {[type]}      [description]
                 */
                $scope.deleteQunFaCard = function(id) {
                    modalDialog.confirmModal('删除', '是否确认删除？', function() {
                        var params = {
                            WechatCardMessageId: id,
                            serviceid: 'mlf_wechatgroupsend',
                            methodname: 'deleteQunFaCard',
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function() {
                            modalDialog.alertType('删除成功', '', 'success', false, function() {
                                $scope.requestData();
                                forFusionSign.getwxQunfaCont();
                            });
                        });
                    });
                };

                /**
                 * [wxEdit description] 微信已组版编辑
                 *  @param  {[type]} selectedArray,picword [description]
                 * @return {[type]}      [description]
                 */
                $scope.wxEdit = function(selectedArray, picwordid) {
                    var copyArray = angular.copy(selectedArray);
                    wechatBtnService.wxLayoutEditor(copyArray, picwordid, function() {
                        $scope.requestData();
                    });
                };
            },
        };
    },
]);
